import { render } from "./PreenchimentoResult.vue?vue&type=template&id=500d010c&scoped=true"
import script from "./PreenchimentoResult.vue?vue&type=script&lang=js"
export * from "./PreenchimentoResult.vue?vue&type=script&lang=js"

import "./PreenchimentoResult.vue?vue&type=style&index=0&id=500d010c&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\projetos\\senar-sgo\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-500d010c"]])

export default __exports__